//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsPhoenixRestApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type,EditForm$Type,PostForm$Type } from '../genericFlowTypes'

const workflowType = 'Uranus'

export const getTaskData=(uranus:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.URANUS_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,uranus)
            dispatch({
                type: actionTypes.URANUS_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.URANUS_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.URANUS_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,uranusResultset:any,uranus:ReducerState$Type)=>{
    let payload:PostForm$Type={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (uranusResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=uranusResultset.vendorName;
        payload.invNo=uranusResultset.invNo;
        payload.invDate=uranusResultset.invDate;
        payload.poNo=uranusResultset.poNo;
        payload.total=uranusResultset.total;
        payload.isInvalidDoc=uranusResultset.isInvalidDoc?uranusResultset.isInvalidDoc:false;
        payload.isOverrideVendorName=uranusResultset.isOverrideVendorName?uranusResultset.isOverrideVendorName:false;
    }

    if (uranus.reviewQuestions && uranus.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(uranusResultset,uranus.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.URANUS_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.URANUS_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.URANUS_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.URANUS_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsPhoenixRestApi(jwt,workflowType.toLowerCase())
    .then((resp) => resp.json()).then(data =>{
        
        dispatch({type: actionTypes.REFRESH_URANUS_VENDORS_SUCCESS, vendors: data });
        
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_URANUS_VENDORS_ERROR, error: err});
    })
}



// WEBPACK FOOTER //
// ./src/redux/uranus/actions.js